import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Company = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '24',
    defaultHeight: '24',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M9 22.96v-4h6v4m-7-16h.01m7.99 0h.01m-4.01 0h.01m-.01 4h.01m-.01 4h.01m3.99-4h.01m-.01 4h.01m-8.01-4h.01m-.01 4h.01M6 2.96h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-16a2 2 0 0 1 2-2'
      />
    </svg>
  );
};
